import React from 'react';
import {
	Table,
	message,
	Popconfirm,
	Button,
	Icon,
	Input,
	Select,
	Form,
	Modal,
	Row,
	Col,
	Tooltip,
	Tag,
	Pagination,
	Divider,
	Statistic, Avatar
} from 'antd';
import { clientlistAc } from '../../../redux/actions';
import { connect } from 'react-redux';
import moment from 'moment';
import ModalRender from './ModalRender';
import ModalLimitInfo from './ModalLimitInfo';
import editGuaranteeStatus1 from "./editGuaranteeStatus";
import { server } from '../../../config/serverConfig';

import { download, download2 } from "../../../utils";

// 下拉组件和搜索项目组件
import { SearchItems, DropAdd } from './SearchRender';

// 客户授信查询
import findCredit from "./findCredit";
import ClientCreditDrawer from "./ClientCreditDrawer.js";

// 加载中modal
import LoadingModal from "../../../components/loadingModal";
import { app_SET } from "../../../redux/actions/appAction";
import confirmOrderDone from "../../order/controlProductOrder/confirmOrderDone";

function RenderBase({ appRd, clientRd, del, set,app_set, selectLimitInfo, get, getxls, create, update }) {

	//导入本组件所需参数变量
	const { limitInfoData,guaranteeDescribe, modalFlag, data, dataLoading, dataFetchProps, selectedRows, selectedRowKeys, modalVisible, modalType, pwdModalVisible, selectedRow, selectedRowIndex, pagination, searchProps, filePath, clientCreditDrawer } = clientRd;
	const { loginData, screenType, loginUserRoleAuth } = appRd;
	const { roleid, groupid, user_name } = loginData;

	//dataFetchProps
	if (dataLoading) {
		//全局尽量统一通过修改dataLoading来刷新数据，以减少数据不准一。
		// 加载loading
		get({ ...dataFetchProps, ...searchProps });

	}   // {onlyDeletedRows: true,user_name: 'a', roleid: 'admin', order:[['id']], offset: 2, limit: 2}

	//刷新按钮强制刷新，需要提示
	const refreshData = async () => {
		let msg = await get({ ...dataFetchProps, ...searchProps });
		message.info(msg);
	}

	// 自主查询授信 props
	const clientCreditDrawerProps = {
		visible: clientCreditDrawer.visible,
		value: clientCreditDrawer.value,
		// 关闭直接设置
		onClose() {
			set({
				clientCreditDrawer: {
					visible: false,
					value: []
				}
			})
		},
	}

	//定义表头
	const columns = [
		{
			title: 'id',
			dataIndex: 'id',
			key: 'id',
			className: 'align_center',
			width: 80
		},{
			title: '产品模式',
			dataIndex: 'guarantee_type',
			key: 'guarantee_type',
			width: 120,
			render: (text, record) => (
				<div>
					{text !== undefined && text !== null ? (
						<span>
          <Avatar size="small" style={{ marginRight: 8 }}>
            {text === 0 ? '企' : text === 1 ? '大' : ''}
          </Avatar>
          <span style={{ fontSize: '14px', fontWeight: 'normal', color: text === 0 ? '#1890ff' : text === 1 ? '#00bcd4' : 'inherit' }}>
            {text === 0 ? '企信宝' : text === 1 ? '大经宝' : ''}
          </span>
        </span>
					) : (
						''
					)}
				</div>
			),
		},
		{
			title: '反担保标记',
			dataIndex: 'guarantee_status',
			key: 'guarantee_status',
			render: (text, record) =>  text&&text==='1'? <span> <Icon type="check-square" theme="twoTone" /></span> : <span><Icon type="clock-circle" theme="twoTone"  twoToneColor="#9955FF"/></span>,
			width: 100
		},

		{
			title: '客户名称',
			dataIndex: 'cust_name',
			key: 'cust_name',
			width: 180,
			render: (text, record) => (
				<div>
					{record.social_credit_code ?
						<Tooltip placement="topLeft" title={'营业执照:' + record.social_credit_code}>
							{/** 超出宽度换行 */}
							<Tag color="#20B2AA" style={{ maxWidth: "100%" }}>
								<div style={{ whiteSpace: "pre-wrap" }}>
									{text}
								</div>
							</Tag>
						</Tooltip>
						: text}
				</div>
			)
		}, {
			title: 'SAP编码',
			dataIndex: 'sap_no',
			key: 'sap_no',
			className: 'align_center',
			width: 120,
		}, {
			title: '分公司',
			dataIndex: 'subcompany',
			key: 'subcompany',
			className: 'align_center',
			width: 150,
		}, {
			title: '业务经办人',
			dataIndex: 'bizperson',
			key: 'bizperson',
			className: 'align_center',
			render: (text) => (
				<div>
					{text ? (
						<span>
               <Avatar size="small" style={{ marginRight: 8, backgroundColor: '#69c0ff', color: '#fff' }}>
  {text.charAt(0)}
</Avatar>
              <Statistic value={text} valueStyle={{ fontSize: '15px', fontWeight: 'bold' }} />
            </span>
					) : (
						''
					)}
				</div>
			),
			width: 100,
		},   {
			title: '状态',
			dataIndex: 'status',
			key: 'status',
			render: (text) => (
				<Tag color={text !== '批准' ? 'purple' : 'blue'}>{text === '批准' ? text : '待激活'}</Tag>
			),
			width: 120,
		},
		{
			title: '银行名称',
			dataIndex: 'm_clientLegalPerson',
			key: 'bank_id',
			render: text => text.length > 0 && text[0].bank_id === 'b001' ? '锡商行' : '其他银行',
			width: 100,
		}, {
			title: '用户名',
			dataIndex: 'm_clientLegalPerson',
			key: 'user_name',
			render: (text, record) => (
				<div>
					{record.m_clientLegalPerson.length > 0 && record.m_clientLegalPerson[0].mobile_no ? <Tooltip placement="topLeft" title={record.m_clientLegalPerson[0].mobile_no}><Tag color="#0072BC">{text.length > 0 ? text[0].user_name : "-"}</Tag>  </Tooltip>
						: text.length > 0 ? text[0].user_name : "-"}

				</div>
			),width: 100,
		}, {
			title: '钱包状态',
			dataIndex: 'wallet_status',
			key: 'wallet_status',
			width: 120,
		}, {
			title: '授信额度',
			dataIndex: 'loan_credit',
			key: 'loan_credit',
			width: 120,
		},{
			title: '客户归属',
			dataIndex: 'groups',
			key: 'groups',
			width: 100,
			render: (groups, record) => {
				const tags = [];

				if (groups && groups.includes('dj')) {
					tags.push(<Tag color="#1890ff">大经</Tag>);
				}
				if (groups && groups.includes('ytg')) {
					tags.push(<Tag color="#00bcd4">优特钢</Tag>);
				}

				return (
					<div>
						{tags}
					</div>
				);
			},
		}, {
			title: '赊销额度(元)',
			dataIndex: 'inner_credit',
			key: 'inner_credit',
			render: (text) => (
				<div>
					{text ? <span><Statistic value={text} precision={2} valueStyle={{ fontSize: '15px', fontWeight: 'bold', color: '#E9967A' }} /></span> : ''

					}
				</div>
			),
			width: 130,
		}, {
			title: '审核人',
			dataIndex: 'approver',
			key: 'approver',
			width: 150,
		}, {
			title: '审核时间',
			dataIndex: 'approver_time',
			key: 'approver_time',
			render: text => text ? moment(text).format('YYYY-MM-DD HH:mm') : null,  //GW:注意时间可能是空
			width: 150,
		}, {
			title: '到期时间',
			dataIndex: 'finished_at',
			key: 'finished_at',
			render: text => text ? moment(text).format('YYYY-MM-DD HH:mm') : null,  //GW:注意时间可能是空
			width: 150,
		},{
			title: '利率',
			dataIndex: 'loan_rate',
			key: 'loan_rate',
			width: 120,
			render: (text, record) => (
				text !== null ? (
					<Statistic value={text} precision={3} valueStyle={{ fontSize: '15px', fontWeight: 'bold', color: 'gold' }} />
				) : (
					<Tag color="#d3d3d3">暂无</Tag>
				)
			)
		},
		{
			title: '担保合同',
			dataIndex: 'guarantee_contract_url',
			key: 'guarantee_contract_url',
			render: (text) => {
				if (text) {
					let hrefStr = server.path + text;
					return <a href={hrefStr} target='_blank'>查看</a>
				}
				return <span>未上传</span>

			},width: 120,
		},{
			title: '查询授信',
			dataIndex: 'social_credit_code',
			key: 'social_credit_code',
			width: 120,
			fixed: 'right', // 将列固定在右侧
			render: (social_credit_code, record) => (
				<Button onClick={() => {
					const { social_credit_code, guarantee_type } = record;

					if (social_credit_code) {
						// 有社会信用代码，查询
						findCredit(social_credit_code, guarantee_type).then(result => {
							set({
								clientCreditDrawer: {
									visible: true,
									value: result.data
								}
							});
						}).catch(() => {
							message.error("查询失败");
						});
					} else {
						// 没有社会信用代码，直接返回空
						set({
							clientCreditDrawer: {
								visible: true,
								value: []
							}
						});
					}
				}}>
					<Icon type="search" />查询
				</Button>
			),
		}

	];

	//定义移动界面表头
	const mobileColumns = [{
		title: '客户列表',
		dataIndex: 'cust_name',
		key: 'cust_name',
		render: (text, record) => {
			let hrefStr = server.path + record.guarantee_contract_url;
			return (
				<span>
					<Row><Col><Tag color="#0072BC">{record.cust_name}</Tag></Col></Row>
					<Row>{record.wallet_status}
						<Col><Tag color="#87d068">{record.status}</Tag></Col>
					</Row>
					<Row>
						{record.guarantee_contract_url && <a href={hrefStr} target='_blank'>业务合同</a>}
					</Row>


				</span>
			)
		}
	}];

	const rowSelection = {
		selectedRowKeys,
		selectedRows,
		onSelect: (record, selected, selectedRows, nativeEvent) => {
			if (selected) {
				set({ selectedRowKeys: [record.id], selectedRow: record, selectedRows: [record] })
			} else { set({ selectedRowKeys: [], selectedRow: {}, selectedRows: [] }) }
		},
		//onChange: (selectedRowKeys, selectedRows) => { SET({selectedRowKeys, selectedRows}) }
	};



	const BtnHandle = async (e) => {
		if (e.target.name === 'update') {
			set({ modalVisible: true, modalType: 'update' });
		}
		if (e.target.name === 'download') {
			let hrefUrl = await getxls();
			download2(hrefUrl, '');

		}

	}
	const BtnQueryLimit = async (e) => {
		console.log(selectedRow)
		// set loading =true
		app_set({APPloading: true});
		set({ dataLoading: true })
		let res = await selectLimitInfo(selectedRow);
		console.log(res)
		app_set({APPloading: false});
		set({ modalFlag: true, dataLoading: false })
	}

	const editGuaranteeStatus = async() => {
		let guarantee_status = '';
		if (selectedRow.guarantee_status === '1') {
			guarantee_status = '0';
		} else {
			guarantee_status = '1';
		}
		await editGuaranteeStatus1({ id: selectedRow.id, guarantee_status: guarantee_status }).then(
			msg => {
				message.success(msg);

				set({ dataLoading: true });
			}).catch(err => {
			set({ dataLoading: false })
			message.error(err);
		})
	}

	const BtnDel = (e) => {
		let data = { id: selectedRow.id, status: '失效' }
		update(data, selectedRowIndex).then(res => message.info(res));

	}

	// 搜索完成动作
	const onFinish = (data) => {
		// 1  先清空分页中原有的当前页，pagination.current =1
		// 2 将搜索内容更新到 searchProps内。
		// 3 更新dataLoading 为true。

		let paginationNew = { ...pagination }
		paginationNew.current = 1;

		set({ dataLoading: true, pagination: { ...paginationNew }, searchProps: data });
	}

	pagination.onChange = (page, pageSize) => {
		if (isNaN(pageSize)) {
			//这是异常刷新，不记录任何值,比如排序刷新
			return;
		}
		let paginationNew = { ...pagination };
		paginationNew.current = page;  //如果page是1，直接提交即可
		paginationNew.pageSize = pageSize;
		set({ pagination: paginationNew, dataLoading: true });

	}

	pagination.onShowSizeChange = (current, size) => {
		let paginationNew = { ...pagination };
		let overcount = paginationNew.pageSize * (paginationNew.current - 1);

		paginationNew.current = 1 + parseInt(overcount / size);

		paginationNew.pageSize = size;
		set({ pagination: paginationNew, dataLoading: true });

	}


	const tableDefinition = {
		rowKey: 'id',
		loading: dataLoading,
		pagination: pagination,
		size: 'small',
		columns: screenType == 'pc' ? columns : mobileColumns,
		dataSource: data,
		//expandedRowRender: record => <p style={{ margin: 0}}>{JSON.stringify(record,['user_id','mobile','email','roleid','groupid','subgroup','mail_user_rule','mail_grp_rule'])}</p>,
		//rowSelection: rowSelection,
		onRow: (record, index) => {

			return {
				onClick: event => {
					// 添加条件判断和 set 方法的调用

							set({selectedRow: record, selectedRowIndex: index });
				}
			}
		},
		rowClassName: (record, index) => index === selectedRowIndex ? 'selectedItem' : '',
		scroll: { x: 800, y: window.innerHeight - 370 },
	}

	const modalRenderProps = {

		item: modalType === 'create' ? {} : selectedRow,
		type: modalType,
		visible: modalVisible,
		onOk(data) {

			set({ modalVisible: false })
			if (modalType === 'create') {
				create(data).then(res => {
					message.info(res);
				})
			}

			if (modalType === 'update') {
				update(data, selectedRowIndex).then(res => {
					return message.info(res);

				});
				console.log(data)
			}
		},



		onReject(data) {

			set({ modalVisible: false })
			update(data, selectedRowIndex).then(res => message.info(res));
		},
		onCancel() {
			set({ modalVisible: false })
		},
	}


	const modalLimitInfoProps = {

		item: limitInfoData,
		visible: modalFlag,

		onCancel() {
			set({ modalFlag: false })
			refreshData();
		},
	}

	const ModalRenderGene = () => <ModalRender {...modalRenderProps} />;

	//定义一个具有属性的弹窗 查询授信的弹窗
	const ModalLimitInfoRender = () => <ModalLimitInfo {...modalLimitInfoProps} />;

	return (
		<div>
			<Row style={{ marginBottom: 10 }}>
				<Col span={24}><Input.Group compact size="large">
					<Button onClick={refreshData}  > <Icon type="sync" style={{ color: 'green' }} />刷新</Button>
					<Button onClick={BtnHandle} name='update' disabled={selectedRowIndex === -1} hidden={loginUserRoleAuth.indexOf('/client/list/btn001') == -1}> <Icon type="edit" />修改</Button>

					<Popconfirm title="Are you sure？" okText="Yes" cancelText="No"
						onConfirm={BtnDel} disabled={selectedRowIndex === -1} >
						<Button disabled={selectedRowIndex === -1} hidden={loginUserRoleAuth.indexOf('/client/list/btn002') == -1}> <Icon type="delete" />禁用</Button>
					</Popconfirm>
					<Button onClick={BtnQueryLimit} name='queryLimitInfo' disabled={selectedRowIndex === -1} > <Icon type="search" />查询授信</Button>
					<Button hidden={loginUserRoleAuth.indexOf('/client/list/btn003') == -1} onClick={editGuaranteeStatus} name='editGuaranteeStatus' disabled={selectedRowIndex === -1} >
						{selectedRow.guarantee_status === '1' ? '取消标记' : '打上标记'}
						{/*標記*/}
						<Icon type="pushpin" />
					</Button>

					<Divider type={"vertical"} />
					<Button type='primary' onClick={BtnHandle} name='download' hidden={loginUserRoleAuth.indexOf('/client/list/download') == -1} ><Icon type="file-excel" />导出</Button>
					<DropAdd></DropAdd>
				</Input.Group>

				</Col>

			</Row>
			<Row>
				<Col span={24}>
					<SearchItems onFinish={onFinish}></SearchItems>
				</Col>
			</Row>
			<Table className='logListTable' {...tableDefinition} />
			{modalVisible && <ModalRenderGene />}
			{/*把引入的model 弹窗写出来 给一个modalFlag 判断是否显示*/}
			{modalFlag && <ModalLimitInfoRender />}
			<LoadingModal></LoadingModal>
			<ClientCreditDrawer {...clientCreditDrawerProps}></ClientCreditDrawer>
		</div>);


}

const mapStateToProps = (state) => {
	return {
		clientRd: state.clientRd,
		appRd: state.appReducer
	}
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		set: (value) => dispatch(clientlistAc.SET(value)),
		get: (value) => dispatch(clientlistAc.GET(value)),
		getxls: (value) => dispatch(clientlistAc.GETXLS(value)),
		update: (value, index) => dispatch(clientlistAc.UPDATE(value, index)),
		selectLimitInfo: (value) => dispatch(clientlistAc.SELECTLIMITINFO(value)),
		app_set: (value)=>dispatch(app_SET(value))
	}
}

const ClientList = connect(mapStateToProps, mapDispatchToProps)(RenderBase);

export default ClientList;
